import * as PIXI from "pixi.js";
import Game from "../Game";
import TextureManager from "../managers/TextureManager";
import { Coord } from "../types/Interface";
import addInteractivity from "../utils/addInteractivity";
import { CustomCursorType } from "../entities/UI/CustomCursor/CustomCursor";
import LoadingLayerFactory from "./LoadingLayerFactory";


export default class LoadingLayer extends PIXI.Container {
  private Game = Game.getInstance();
  private bg = this.addChild(new PIXI.Graphics());
  private button: PIXI.Graphics = this.addChild(new PIXI.Graphics());
  private buttonTitle: PIXI.Text = this.addChild(new PIXI.Text({ text: "Start Game" }));
  private handlePress: () => void;
  private elementScale = .5;
  private coord!: Coord;

  constructor(handlePress: () => void) {
    super();
    this.handlePress = handlePress;
    this.addCoord();
    this.isVertical();
    this.addBg();
    this.addLogo();
    this.addLoadingButton();
    this.addToStage();
  }
  private addToStage = () => this.Game.stage.addChild(this);
  private addCoord() {
    const dim = this.Game.getDim();
    this.coord = { x: dim.WIDTH / 2, y: dim.HEIGHT * 5 / 8 }
  }
  private isVertical() {
    const dim = this.Game.getDim();
    if (dim.WIDTH < dim.HEIGHT) { this.elementScale = .8 }
    return dim.WIDTH < dim.HEIGHT;
  }
  private addBg() {
    const dim = this.Game.getDim();
    this.bg
      .rect(0, 0, dim.WIDTH, dim.HEIGHT)
      .fill({ color: 0xff0000, alpha: 0 });

    addInteractivity(this.bg, {}, CustomCursorType.default)
  }
  private addLogo() {
    const logoTexture = TextureManager.getLogo();
    const logo = this.addChild(new PIXI.Sprite(logoTexture));
    logo.anchor.set(.5);
    logo.scale.set(this.elementScale);
    logo.x = this.coord.x;
    logo.y = this.coord.y - 260 * this.elementScale;
  }
  private addLoadingButton() {
    LoadingLayerFactory.drawButton(this.button, 100)
    this.button.position.copyFrom(this.coord)

    LoadingLayerFactory.setButtonTitle(this.buttonTitle);
    Object.assign(this.buttonTitle, this.coord);
  }
  private addButtonInteractivity() {
    const handleUpFunc = () => {
      this.visible = false;
      this.handlePress();
    }
    addInteractivity(this.button, { handleUpFunc }, CustomCursorType.pointer, undefined, true);
  }
  drawLoadingButton(percent: number) {
    LoadingLayerFactory.drawButton(this.button, percent);

    if (percent == 100) {
      this.buttonTitle.visible = true;
      this.addButtonInteractivity();
    }
  }
}